// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-smaller);
  min-width: 110px;
  color: var(--color-red);
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.label {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/not-for-clinical-use/not-for-clinical-use.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AACF;;AAEA;EACE,SAAA;AACF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-smaller);\n  min-width: 110px;\n  color: var(--color-red);\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.label {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
